"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_json_tree_1 = __importDefault(require("react-json-tree"));
const defaultTheme = {
    base00: "transparent",
    base01: "#073642",
    base02: "#586e75",
    base03: "#657b83",
    base04: "#839496",
    base05: "#93a1a1",
    base06: "#eee8d5",
    base07: "#fdf6e3",
    base08: "#dc322f",
    base09: "#cb4b16",
    base0A: "#b58900",
    base0B: "#66BB6A",
    base0C: "#2aa198",
    base0D: "#268bd2",
    base0E: "#6c71c4",
    base0F: "#d33682"
};
function getTheme(themeName) {
    switch (themeName) {
        case "light":
        case "classic": {
            return defaultTheme;
        }
        case "dark":
        case "nteract": {
            return Object.assign({}, defaultTheme, { base0B: "#EDF3F7" });
        }
        case "halloween": {
            return Object.assign({}, defaultTheme, {
                base03: "#E28410",
                base0B: "#A22222",
                base0D: "#000000"
            });
        }
        default:
            return defaultTheme;
    }
}
class JsonDisplay extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.shouldExpandNode = () => {
            if (this.props.metadata && this.props.metadata.expanded) {
                return true;
            }
            return false;
        };
    }
    static handles(mimetype) {
        return mimetype.startsWith("application/json");
    }
    render() {
        const theme = getTheme(this.props.theme);
        return (react_1.default.createElement(react_json_tree_1.default, { data: this.props.data, theme: theme, invertTheme: false, hideRoot: true, shouldExpandNode: this.shouldExpandNode }));
    }
}
JsonDisplay.MIMETYPE = "application/json";
JsonDisplay.defaultProps = {
    data: {},
    mediaType: "application/json",
    theme: "light",
    metadata: {}
};
exports.default = JsonDisplay;
